// 解决kmui需要tab页id

export default {
  mounted() {
    const $el = this.$el;
    if (
      ($el.parentNode && $el.parentNode.className !== 'block-body-main')
      || !$el.setAttribute
      || !this.$route
    ) return ;
    const id = this.$route.name
    $el.setAttribute("id", id);
    if (!window.__kmui__) {
      window.__kmui__ = {};
    }
    window.__kmui__.getCurrentTabRootId = function() {
      return id;
    }
  },
  activated() {
    const $el = this.$el;
    if (
      ($el.parentNode && $el.parentNode.className !== 'block-body-main')
      || !$el.setAttribute
      || !this.$route
    ) return ;
    const id = this.$route.name
    window.__kmui__.getCurrentTabRootId = function() {
      return id;
    }
  }
}